import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Stellenausschreibung = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      <section className="relative py-20 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Aktuelle Stellenausschreibung
          </h1>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 mb-8">
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Liebe Interessenten,
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              unsere Familie soll wachsen, wir eröffnen erst eine neue Tour wenn wir das Personal hierfür haben und nicht wie es oftmals so üblich ist wenn die Mitarbeiter überlastet sind, aus diesem Grund suchen wir ins folgenden Bereichen Personal:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <Link 
              to="/leipzig/karriere/pflegehelfer"
              className="bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white p-8 rounded-2xl hover:from-turquoise-500 hover:to-blue-800 transition-all shadow-lg hover:shadow-2xl transform hover:-translate-y-1"
            >
              <div className="text-4xl mb-4">👨‍⚕️</div>
              <h3 className="text-2xl font-bold mb-2">Pflegehelfer (m, w, d)</h3>
              <p className="text-turquoise-100">Voll- und Teilzeit</p>
              <div className="mt-4 text-right">
                <span className="text-blue-200">Mehr erfahren →</span>
              </div>
            </Link>

            <Link 
              to="/leipzig/karriere/pflegefachkraft"
              className="bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white p-8 rounded-2xl hover:from-turquoise-500 hover:to-teal-800 transition-all shadow-lg hover:shadow-2xl transform hover:-translate-y-1"
            >
              <div className="text-4xl mb-4">👩‍⚕️</div>
              <h3 className="text-2xl font-bold mb-2">Pflegefachkraft (m, w, d)</h3>
              <p className="text-turquoise-100">Voll- und Teilzeit</p>
              <div className="mt-4 text-right">
                <span className="text-teal-200">Mehr erfahren →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Stellenausschreibung;